module.exports = __webpack_public_path__ + "assets/from-icon.29351e65.svg";